<template>
  <div class="table-list">
    <div class="table-head" v-if="data && data.length > 0">
      <div class="table-head-item" v-for="item in headKey" :key="item.key" :style="{'min-width': item.width + 'px'}">{{item.title}}</div>
    </div>
    <div class="table-content">
      <div class="tr" v-for="(tr,index) in data" :key="index + '_tr'">
        <div class="tr-td" v-for="td in headKey" :key="td.key" :style="{'min-width': td.width + 'px'}">
          <slot :name="td.key" :row="tr" :index="index">
            <toolTip style="width:100%;" :title="getKeyList(tr,td.key)">{{getKeyList(tr,td.key)}}</toolTip>
          </slot>
        </div>
      </div>
    </div>
    <div class="not-tip" v-if="!loading && data.length === 0">{{tip}}</div>
  </div>
</template>
<script>

export default {
  props: ['data', 'tip', 'loading'],
  data() {
    return {
      headKey: [{
        key: 'job_number',
        title: '工号'
      }, {
        key: 'realname',
        title: '姓名',
        width: 240
      }, {
        key: 'job.job_name',
        title: '职位'
      }, {
        key: 'email',
        title: '邮箱'
      }, {
        key: 'phone',
        title: '电话'
      }, {
        key: 'department.name',
        title: '所属部门'
      }]
    }
  },
  mounted() {
  },
  methods: {
    getKeyList(row, key) {
      if (key.indexOf('.') > -1) {
        let arr = key.split('.')
        let result = JSON.parse(JSON.stringify(row))
        for (let i = 0; i < arr.length; i++) {
          if (!result[arr[i]]) {
            return '-'
          } else {
            result = result[arr[i]]
          }
        }
        return result
      } else {
        return row[key] === '' || row[key] === null || row[key] === undefined ? '-' : row[key]
      }
    }
  }
}
</script>
<style lang="scss">
.table-list {
  min-width: 100%;
  color: initial;
  font-size: 14px;
  .not-tip {
    font-size: 14px;
    color: rgba(32, 32, 32, 0.6);
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
  .table-head {
    display: flex;
    color: rgba(32, 32, 32, 0.6);
    font-size: 14px;
    min-width: 100%;
  }
  .table-content {
    min-width: 100%;
  }
  .table-head-item {
    padding: 12px 10px 12px 17px;
    flex: 1;
    min-width: 150px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
  }
  .table-head-item:first-child {
    padding-left: 40px;
  }
  .tr {
    display: flex;
    &:hover .tr-td{
      background-color: #F6F6F6;
    }
  }
  .tr-td {
    transition: all .3s;
    height: 48px;
    line-height: 48px;
    padding: 0 17px;
    flex: 1;
    min-width: 150px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
  }
  .tr-td:first-child {
    padding-left: 40px;
  }
}
</style>
